import React from 'react';
import './Skills.css';
import content from '../data/content.json';
import { resolveAssetPath } from '../utils/content';
import IconSphere from './IconSphere';

function Skills() {
  const uiAssets = content.site?.assets ?? {};
  const settingsIcon = resolveAssetPath(uiAssets.settingsIcon || '/assets/ui/icons8-settings-50.png');
  const desktopIcon = resolveAssetPath(uiAssets.desktopIcon || '/assets/ui/icons8-desktop-50.png');
  const paletteIcon = resolveAssetPath(uiAssets.paletteIcon || '/assets/ui/icons8-paint-palette-with-brush-32.png');
  const collageImage = resolveAssetPath(uiAssets.collageImage || '/assets/misc/dmitry-chernyshov-mP7aPSUm7aE-unsplash.webp');

  return (
    <div className="skills-section-wrapper">
    <div className="skills-section" id="skills">
      <h2 className="skills-main-title">
        Focusing on the <span className="highlight-purple">Best</span>
      </h2>

      <div className="skills-grid">
        {/* Left Card: Tech Stack */}
        <div className="skill-card tech-stack-card">
          <div className="tech-scatter-container">
            <IconSphere />
          </div>
          
          <div className="card-content">
            <h3 className="card-title">
              <span className="highlight-purple">Multiple</span> Tech Stack
            </h3>
            <p className="card-desc">
              I have worked with multiple technologies and frameworks to build scalable and efficient applications.
            </p>
          </div>
        </div>

        {/* Top Right Card: Dev & Design */}
        <div className="skill-card dev-design-card">
          <div className="flow-diagram">
            {/* Replace the src with your own image paths or SVG imports */}
            <div className="flow-node">
              <img src={settingsIcon} alt="Dev Logo" className="custom-flow-icon" />
            </div>
            <div className="flow-line"></div>
            <div className="flow-node active-node">
              <img src={desktopIcon} alt="Main Logo" className="custom-flow-icon active-icon" />
            </div>
            <div className="flow-line"></div>
            <div className="flow-node">
              <img src={paletteIcon} alt="Design Logo" className="custom-flow-icon" />
            </div>
          </div>
          <div className="card-content">
            <h3 className="card-title">
              Dev & <span className="highlight-purple">Design</span>
            </h3>
            <p className="card-desc">
              Excels in both development and design to create a seamless and intuitive user experience.
            </p>
          </div>
        </div>

        {/* Bottom Right Card: Collaborations */}
        <div className="skill-card collab-card">
          <div className="macbook-wrapper">
             <img 
               src={collageImage}
               alt="Macbook Pro" 
               className="macbook-img" 
             />
          </div>
          <div className="card-content collab-content">
            <h3 className="card-title">
            Graphic Designing and <span className="highlight-purple">Video Editing</span>
            </h3>
            <p className="card-desc">
              
            </p>
          </div>
        </div>
        
      </div>
    </div>
    </div>
  );
}

export default Skills;
